import { FilterOperator, MetricView, PurchaseCountry } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

type CustomMetricView = MetricView & { purchaseCountry: PurchaseCountry };

export class PurchaseCountryFilter extends MetricFilter<PurchaseCountry> {
  public field = 'purchase_country';
  public operator = FilterOperator.IN;

  constructor(purchaseCountries?: PurchaseCountry[]) {
    super(purchaseCountries);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<PurchaseCountryFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: PurchaseCountryFilter): this {
    if (!(newFilter instanceof PurchaseCountryFilter)) return this;
    if (newFilter.values === undefined) return new PurchaseCountryFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new PurchaseCountryFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return (metrics as unknown as CustomMetricView[]).filter((metric) =>
      this.values.some((value) => value === metric.purchaseCountry),
    ) as unknown as K[];
  }
}
